var map = {
	"./Football .webp": "a7d2",
	"./football 2.webp": "ab8f",
	"./football 3.webp": "87c1",
	"./horseracing 2.webp": "ac8e",
	"./horseracing 3 .webp": "3ffd",
	"./horseracing.webp": "57ae",
	"./slide1.webp": "f016",
	"./slide2.webp": "ec5d",
	"./slide3.webp": "3ad0",
	"./slide4.webp": "c3dd",
	"./slidesmall.gif": "8a17",
	"./slidesmall.png": "168a",
	"./slidesmall.webp": "06cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32a2";